import { z } from 'zod';
/**
 * RFC 9457 problem details returned by every API error (SRS §7) with content type
 * `application/problem+json`.
 */
export const problemFieldErrorSchema = z.object({
    /** Dotted path of the invalid field, e.g. `salary.components.0.amount`. */
    path: z.string(),
    message: z.string(),
    code: z.string(),
});
export const problemSchema = z.object({
    type: z.string().describe('Problem type URI; `about:blank` for plain HTTP errors'),
    title: z.string().describe('Short, human-readable summary (the HTTP status phrase)'),
    status: z.number().int().min(400).max(599),
    detail: z.string().optional().describe('Explanation specific to this occurrence'),
    instance: z.string().optional().describe('Request path (query string omitted)'),
    requestId: z.string().optional().describe('Correlates with the X-Request-Id header and logs'),
    code: z
        .string()
        .optional()
        .describe('Machine-readable reason for clients that branch on it, e.g. a sign-in error code'),
    errors: z
        .array(problemFieldErrorSchema)
        .optional()
        .describe('Field errors (validation failures only)'),
});
//# sourceMappingURL=problem.js.map